import React, { useEffect, useContext } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
// import ConfirmAlert from 'modules/common/components/ConfirmAlert';
// import useDebounce from 'modules/common/components/UseDebounce';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
// import EmptyState from 'modules/common/components/EmptyState';
import * as actions from '../action';
import * as c from '../constant';
import PenaltyContent from './PenaltyContent';
import CreateModal from '../components/CreateModal';
import UpdateModal from '../components/UpdateModal';

// const form = {
//   keyword: '',
// };

function PenaltyContainer({
  match,
  history,
  getPenaltyList,
  penaltyList,
  isLoading,
  // removePenalty,
  penaltyListPager,
  // getSinglePenalty,
  ordinanceRevisionId,
}) {
  // const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  // const handleOnChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal />,
      title: 'Add Penalty',
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Penalty',
      modalSize: 'modal-md',
    });
  };

  // const handleRemove = (data) => (e) => {
  //   e.preventDefault();
  //   ConfirmAlert(
  //     'Are you sure, you want to remove this Penalty?',
  //     () => {
  //       removePenalty(data.id);
  //       // UpdateData();
  //       history.push(`/rpt/settings/penalties`);
  //       getPenaltyList();
  //     },
  //     () => { },
  //     {
  //       yesLabel: 'Confirm',
  //       noLabel: 'Cancel',
  //     }
  //   );
  // };

  const UpdateData = () => {
    getPenaltyList({ ordinance_revision_id: ordinanceRevisionId });
    return () => {
      setModal({ isOpen: false });
    };
  };

  useEffect(() => {
    UpdateData();
  }, [ordinanceRevisionId]);

  // const param = {
  //   q: formData.keyword,
  //   sort_by: 'asc',
  // };

  // const handleOnChange = (e) => {
  //   setFormData({
  //     ...formData,
  //     [e.target.name]: e.target.value,
  //   });
  // };

  // const debouncedSearchTerm = useDebounce(formData, 500);

  // const param = {
  //   q: formData.keyword,
  //   sort_by: 'asc'
  // };
  // useEffect(() => {
  //   if (debouncedSearchTerm) {
  //     getPenaltyList({ q: formData.keyword });
  //   } else {
  //     setFormData([]);
  //   }
  // }, [debouncedSearchTerm]);

  const noSearch = true;

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:penaltyId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            noSearch={noSearch}
            noPager={noSearch}
            moduleName="Penalty"
            getData={getPenaltyList}
            // setParams={param}
            // setKeyword={handleOnChange}
            // keyword={_.get(formData, 'keyword') || ''}
            // keywordPlaceholder="Search..."
            pathName={`${match.path}/:penaltyId?`}
            listName="Penalties"
            label="Penalties"
            renderItem={(item) => (
              <div className="p-3">{_.get(item, 'attributes.name')}</div>
            )}
            isLoading={isLoading}
            selected={params.penaltyId}
            data={penaltyList}
            dataPager={penaltyListPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:penaltyId?`}
                    render={() => (
                      <PenaltyContent
                        handleAddModal={handleAddModal}
                        handleEdit={handleEdit}
                        UpdateData={UpdateData}
                        // handleRemove={handleRemove}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:penaltyId?`}
                  render={() =>
                    !params.penaltyId && penaltyList.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(penaltyList, '0.id')}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

PenaltyContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getPenaltyList: PropTypes.instanceOf(Function).isRequired,
  penaltyList: PropTypes.instanceOf(Array).isRequired,
  penaltyListPager: PropTypes.instanceOf(Object).isRequired,
  // removePenalty: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
  // getSinglePenalty: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  penaltyList: _.get(api, `${c.GET_PENALTY}.list`) || [],
  penaltyListPager: _.get(api, `${c.GET_PENALTY}.pager`) || {},
  isLoading: _.get(api, 'loading', []).indexOf(c.GET_PENALTY) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(PenaltyContainer);
